export default class ItemPredicate {
  itemProperty: string;
  expectedValue: unknown;


  constructor(itemProperty: string, expectedValue: unknown) {
    this.itemProperty = itemProperty;
    this.expectedValue = expectedValue;
  }
}
